/** Class representing a method not implemented
 *  @extends Error
 */

const METHOD_NOT_IMPLEMENTED_ERROR_PREFIX = 'api method not implemented, method name: ';

export default class NotImplementedError extends Error {
    /**
     * Create a NotImplementedError
     * @param {string} methodName
     */
    constructor(methodName) {
        const error = `${METHOD_NOT_IMPLEMENTED_ERROR_PREFIX}${methodName}`;
        super(error);
    }
}
